import React, { lazy } from "react";
import Page from "components/Page";
import { Props } from "./Dashboard";

const Dashboard = lazy(() => import("./Dashboard"));

export default (props: Props) => (
  <Page>
    <Dashboard />
  </Page>
);
